module.exports = __webpack_public_path__ + "media/images/writer/reservation/bg-b955963038e8a24fb777d3311d53e714.png";